import { ModalHeader, GenericModalFooter } from "@/shared/components";
import { Envelope } from "@/shared/icons";
import { Ul, Li, TableWrapper } from "./style";
import { ModalProps } from "@/shared/types";
import {
	FontFamilies,
	ForegroundColors,
	Modal,
	TextColors,
	Typography,
	ButtonSize,
} from "@abel-technologies-as/components";
import { ConfirmaPayoutTable } from "../confirma-payout-table/ConfirmaPayoutTable";
import { ConfirmaPayoutData } from "../confirma-payout-table/ConfirmaPayoutTable.types";
import { useTranslation } from "react-i18next";

type Props = ModalProps & {
	payoutData: ConfirmaPayoutData[];
	onSubmitPayout: () => void;
};

const ConfirmPayout = ({ open, setOpen, payoutData, onSubmitPayout }: Props) => {
	const { t } = useTranslation("dhc");

	const whatHappensNextItems = [
		t("confirm_payout_dhc_payment_date"),
		t("confirm_payout_paycheck_email"),
		t("confirm_payout_final_salary_calculation"),
	];

	return (
		<Modal
			modalFooter={
				<GenericModalFooter
					onCancel={() => setOpen(false)}
					onConfirm={onSubmitPayout}
					confirmLabel={t("continue")}
					variant="default"
					size={ButtonSize.MEDIUM}
				/>
			}
			onClose={() => setOpen(false)}
			height="734px"
			isOpen={open}
			modalHeader={
				<ModalHeader
					icon={<Envelope color={ForegroundColors.Secondary} width="20" height="17" />}
					title={t("confirm_payout")}
					subTitle={t("please_review_before_approval")}
				/>
			}>
			<Typography
				margin="0 0 8px 0"
				fontWeight={600}
				color={TextColors.Secondary}
				fontFamily={FontFamilies.InterSemiBold}
				fontSize="16px"
				lineHeight="24px">
				{t("what_happens_next")}
			</Typography>

			<Ul>
				{whatHappensNextItems.map((item, index) => (
					<Li key={index}>
						<Typography
							color={TextColors.Tertiary}
							fontFamily={FontFamilies.InterRegular}
							lineHeight="24px"
							fontWeight={400}>
							{item}
						</Typography>
					</Li>
				))}
			</Ul>
			<TableWrapper>
				<ConfirmaPayoutTable payoutData={payoutData} />
			</TableWrapper>
		</Modal>
	);
};

export { ConfirmPayout };
